export default "__VITE_PUBLIC_ASSET__63a97ac1__"